import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import React, { useEffect, useRef } from "react";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";
import { getStateFromEntry, useObserver } from "../../hooks/use-observer";
import { toId } from "./to-id";
import type { TranslatedValue } from "@swo/storefront";

const options: IntersectionObserverInit = {
  root: null,
  rootMargin: "0px 0px 0px 0px",
};

export const PDPBarSection: ReactTFC<{
  label: TranslatedValue;
  anchor?: string;
  node: React.ReactNode;
  onVisibilityChange: (e: "top" | "bottom", state: "below" | "visible" | "above") => void;
}> = props => {
  const id = toId(props.anchor || props.label.value);
  const refTop = useRef<HTMLDivElement | null>(null);
  const refBottom = useRef<HTMLDivElement | null>(null);

  useObserver(refTop, s => props.onVisibilityChange("top", s), options);
  useObserver(refBottom, s => props.onVisibilityChange("bottom", s), options);

  return (
    <div
      css={css`
        position: relative;

        --x: 30px;
        ${CSS_MQ.atLeastMd} {
          --x: 50px;
        }
      `}
    >
      <span
        className={"js-pdp-bar-anchor"}
        id={id}
        css={css`
          position: absolute;
          top: -70px;
          height: var(--x);

          z-index: 1;

          pointer-events: none;
        `}
      />

      <span
        className={"js-pdp-bar-top"}
        ref={refTop}
        css={css`
          position: absolute;
          top: 0;
          height: var(--x);

          pointer-events: none;
        `}
      />

      <div>{props.node}</div>

      <span
        className={"js-pdp-bar-bottom"}
        ref={refBottom}
        css={css`
          position: absolute;
          bottom: 0;
          height: var(--x);

          pointer-events: none;
        `}
      />
    </div>
  );
};
